import { TIMEZONE } from "common/config";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isToday from "dayjs/plugin/isToday";
import isTomorrow from "dayjs/plugin/isTomorrow";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { useSyncSentryUser } from "hooks/useSyncSentryUser";
import { AnimatePresence } from "motion/react";
import { useRegisterSW } from "virtual:pwa-register/react";
import "./index.css";
import Routing from "./routing";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isToday);
dayjs.extend(isTomorrow);
dayjs.extend(customParseFormat);
dayjs.tz.setDefault(TIMEZONE);

const App = () => {
  useSyncSentryUser();
  useRegisterSW({ immediate: true });

  return (
    <AnimatePresence mode="wait">
      <Routing />
    </AnimatePresence>
  );
};

export default App;
